<template>
  <FormWrapper
    :isSubmitButton="
      checkPermission(PERMISSIONS, ['admin', 'edit']) && !IS_READONLY
    "
    wrapperClass="height-percent-100 max-height-percent-100"
    :bodyClass="`${
      !GET_LOADING ? 'padding-x-16' : ''
    } padding-top-16 height--max-content margin-bottom-100`"
    :handleSubmit="handleSubmit"
    :loading="loading"
    :hasCloseButton="true"
    :hasFooter="!GET_LOADING"
    :handleClose="handleClose"
  >
    <FormLoading :count="6" :loading="GET_LOADING" class="padding-0">
      <Alert v-if="isCreatedTask" :text="$lang.isCreatedTaskActivityMessage" />
      <Input
        :title="$lang.title"
        :label="$lang.title"
        :placeholder="$lang.title"
        :value="form.title"
        name="title"
        id="title"
        type="text"
        :vuelidateObj="$v.form.title"
        :disabled="IS_READONLY"
        @input="input"
        @focus="resetValidation"
        @blur="checkValidation"
      />
      <TextEditor
        :title="$lang.description"
        :label="$lang.description"
        :placeholder="$lang.description"
        :value="form.description"
        name="description"
        id="description"
        :vuelidateObj="$v.form.description"
        :disabled="IS_READONLY"
        @input="input"
        @focus="resetValidation"
        @blur="checkValidation"
      />
      <Dropdown
        v-if="hasStateDefine"
        :title="$lang.stateDefine"
        :label="$lang.stateDefine"
        :placeholder="$lang.stateDefine"
        :value="form.stateDefine"
        name="stateDefine"
        id="stateDefine"
        :vuelidateObj="$v.form.stateDefine"
        :asyncSearch="getTermStateOptions"
        :insideFeature="true"
        :disabled="isCreatedTask || IS_READONLY"
        @input="input"
        @focus="resetValidation"
        @blur="checkValidation"
      />
      <Dropdown
        :title="`${$lang.pagesReference} (${$lang.optional})`"
        :label="$lang.pagesReference"
        :placeholder="$lang.pagesReference"
        :value="form.pagesReference"
        name="pagesReference"
        id="pagesReference"
        :vuelidateObj="$v.form.pagesReference"
        :asyncSearch="getActionOptions"
        :insideFeature="true"
        :disabled="isCreatedTask || IS_READONLY"
        @input="input"
        @focus="resetValidation"
        @blur="checkValidation"
      />
      <div v-if="hasActivityTiming">
        <div class="font-size-14 color-complementary-400 margin-bottom-24">
          {{ $lang.startActivityTiming }}
        </div>
        <EnumDropdown
          :title="$lang.timeCheckpoint"
          :label="$lang.timeCheckpoint"
          :placeholder="$lang.timeCheckpoint"
          :infoTooltip="$lang.timeCheckpointTooltip"
          :value="form.timeCheckpoint"
          name="timeCheckpoint"
          id="timeCheckpoint"
          :parentOptions="timeCheckpointOptions"
          :vuelidateObj="$v.form.timeCheckpoint"
          :insideFeature="true"
          :disabled="isCreatedTask || IS_READONLY"
          @input="input"
          @focus="resetValidation"
          @blur="checkValidation"
        />
        <Input
          :title="`${$lang.viewTime} (${$lang.minute})`"
          :label="$lang.viewTime"
          :placeholder="$lang.viewTime"
          :value="form.viewTime"
          name="viewTime"
          id="viewTime"
          type="text"
          :vuelidateObj="$v.form.viewTime"
          :disabled="isCreatedTask || IS_READONLY"
          @input="input"
          @focus="resetValidation"
          @blur="checkValidation"
        />
        <EnumDropdown
          :title="$lang.comparisonCondition"
          :label="$lang.comparisonCondition"
          :placeholder="$lang.comparisonCondition"
          :infoTooltip="$lang.comparisonConditionTooltip"
          :value="form.comparisonCondition"
          name="comparisonCondition"
          id="comparisonCondition"
          :vuelidateObj="$v.form.comparisonCondition"
          :parentOptions="comparisonConditionOptions"
          :insideFeature="true"
          :disabled="isCreatedTask || IS_READONLY"
          @input="input"
          @focus="resetValidation"
          @blur="checkValidation"
        />
        <Input
          :title="`${$lang.durationActivity} (${$lang.minute})`"
          :label="$lang.durationActivity"
          :placeholder="$lang.durationActivity"
          :infoTooltip="$lang.durationActivityTooltip"
          :value="form.durationActivity"
          name="durationActivity"
          id="durationActivity"
          type="text"
          :vuelidateObj="$v.form.durationActivity"
          :disabled="isCreatedTask || IS_READONLY"
          @input="input"
          @focus="resetValidation"
          @blur="checkValidation"
        />
        <fade-transition>
          <div
            v-if="generateTimingMessage"
            class="background-light-gray color-complementary-300 font-size-12 border-radius-8 text-justify padding-8"
            v-html="generateTimingMessage"
          ></div>
        </fade-transition>
      </div>
      <Checkbox
        :label="$lang.startAtTime"
        :infoTooltip="$lang.startAtTimeTooltip"
        :value="form.startAtTime"
        name="startAtTime"
        :disabled="form.startAtPeriod || isCreatedTask || IS_READONLY"
        @input="input"
        @change="handleChangeStartAtTime"
      />
      <Checkbox
        v-if="form.durationActivity && !form.startAtTime"
        :label="$lang.startAtPeriod"
        :infoTooltip="$lang.startAtPeriodTooltip"
        :value="form.startAtPeriod"
        name="startAtPeriod"
        :disabled="isCreatedTask || IS_READONLY"
        @input="input"
      />
      <Checkbox
        :label="$lang.previousStepRequired"
        :infoTooltip="$lang.previousStepRequiredTooltip"
        :value="form.previousStepRequired"
        name="previousStepRequired"
        :disabled="isCreatedTask || IS_READONLY"
        @input="input"
      />
      <AttachmentTempUploader
        v-if="mode === 'ADD'"
        :label="$lang.uploadFile"
        :hasEditTitle="true"
        uploaderName="activity"
        @getFiles="getTempFiles"
        @remove="removeFile"
      />
    </FormLoading>
  </FormWrapper>
</template>

<script>
import inputMixin from "@/mixin/inputMixin.vue";
import AttachmentTempUploader from "@/components/re-design/uploader/AttachmentTempUploader.vue";
import Alert from "../alert/Alert.vue";
import {
  FormWrapper,
  FormLoading,
  Input,
  TextEditor,
  Dropdown,
  EnumDropdown,
  Checkbox,
} from "@/components/re-design/forms";
import { required, requiredIf, numeric } from "vuelidate/lib/validators";
import { pathOr } from "ramda";
import {
  generateError,
  removeInArray,
  toastAlert,
  checkPermission,
  renderEumOptions,
} from "@/shared/utils";
import { getActionCombo, getTermStateCombo } from "@/services";
export default {
  mixins: [inputMixin],
  inject: [
    "handleReloadList",
    "RESOURCE_NAME",
    "RESOURCE_VALUE",
    "TERM_CODE",
    "TERM_ID",
    "PERMISSIONS",
    "GET_LOADING",
    "IS_READONLY",
  ],
  components: {
    FormWrapper,
    FormLoading,
    Input,
    TextEditor,
    Dropdown,
    EnumDropdown,
    Checkbox,
    AttachmentTempUploader,
    Alert,
  },
  props: {
    data: {
      type: Object,
      default: null,
    },
    submitMethod: {
      type: Function,
      default: () => {},
    },
    hasStateDefine: {
      type: Boolean,
      default: false,
    },
    hasActivityTiming: {
      type: Boolean,
      default: true,
    },
    mode: {
      type: String,
      default: "ADD",
    },
  },
  validations() {
    return {
      form: {
        title: { required },
        description: { required },
        stateDefine: {
          required: requiredIf(
            () => this.hasStateDefine && !this.isCreatedTask
          ),
        },
        pagesReference: {},
        timeCheckpoint: {
          required: requiredIf(
            () => this.hasActivityTiming && !this.isCreatedTask
          ),
        },
        viewTime: {
          numeric,
          required: requiredIf(
            () => this.hasActivityTiming && !this.isCreatedTask
          ),
        },
        comparisonCondition: {
          required: requiredIf(
            () => this.hasActivityTiming && !this.isCreatedTask
          ),
        },
        durationActivity: {
          numeric,
          required: requiredIf(
            () => this.hasActivityTiming && !this.isCreatedTask
          ),
        },
      },
    };
  },
  data() {
    return {
      form: {
        title: null,
        description: null,
        stateDefine: null,
        pagesReference: null,
        timeCheckpoint: null,
        viewTime: null,
        comparisonCondition: null,
        durationActivity: null,
        startAtTime: false,
        startAtPeriod: false,
        previousStepRequired: false,
      },
      loading: false,
      comparisonConditionOptions: [
        { id: 0, caption: this.$lang.before },
        { id: 1, caption: this.$lang.after },
      ],
      tempFiles: [],
      isCreatedTask: false,
    };
  },
  computed: {
    timeCheckpointOptions() {
      return renderEumOptions("activity_time_checkpoint", true);
    },
    generateTimingMessage() {
      const { viewTime, comparisonCondition, timeCheckpoint } = this.form;
      const comparisonConditionCaption = pathOr(
        "",
        ["caption"],
        comparisonCondition
      );
      const timeCheckpointCaption = pathOr("", ["caption"], timeCheckpoint);

      const hasData =
        viewTime && comparisonConditionCaption && timeCheckpointCaption;
      return hasData
        ? this.$lang.activityTimingAlertMessage
            .replace(
              "{0}",
              `<span class='font-weight-500 font-size-14'>
              ${viewTime || ""}
              </span>`
            )
            .replace(
              "{1}",
              `<span class='font-weight-500 font-size-14'>${comparisonConditionCaption}</span>`
            )
            .replace(
              "{2}",
              `<span class='font-weight-500 font-size-14'>${timeCheckpointCaption}</span>`
            )
        : null;
    },
  },
  watch: {
    data: {
      immediate: true,
      handler(value) {
        if (value) {
          this.isCreatedTask = value.isCreatedTask;
          // set server data to form
          for (const [key] of Object.entries(this.form)) {
            this.input(key, value[key]);
            if (key === "comparisonCondition") {
              const viewTime = value["viewTime"];
              const generateComparisonConditionId = +(Math.sign(viewTime) >= 0);
              const comparisonCondition = this.comparisonConditionOptions.find(
                ({ id }) => id === generateComparisonConditionId
              );
              this.input(key, comparisonCondition);
            }
            if (key === "timeCheckpoint") {
              const timeCheckPointId = value[key];
              const timeCheckpoint = this.timeCheckpointOptions.find(
                ({ id }) => id === timeCheckPointId
              );
              this.input(key, timeCheckpoint);
            }
          }
        }
      },
    },
  },
  methods: {
    checkPermission,
    handleClose() {
      this.$emit("handleClose");
    },
    async getTermStateOptions(text = null) {
      try {
        const extraQueryString = { term_code: this.TERM_CODE };
        const response = await getTermStateCombo(text, extraQueryString);
        const { options } = response;
        return options;
      } catch (error) {
        generateError(error);
      }
    },
    async getActionOptions(text = null) {
      try {
        const extraQueryString = { resource: this.RESOURCE_NAME };
        const response = await getActionCombo(text, extraQueryString);
        const { options } = response;
        return options;
      } catch (error) {
        generateError(error);
      }
    },
    getTempFiles(files) {
      this.tempFiles = files;
    },
    removeFile(removeCode) {
      const item = this.tempFiles.find(
        ({ clientCode }) => clientCode === removeCode
      );
      removeInArray(item, this.tempFiles);
    },
    handleChangeStartAtTime(value) {
      if (value) {
        this.input("startAtPeriod", false);
      }
    },
    async handleSubmit() {
      this.$v.$touch();
      if (this.$v.$anyError || this.loading) return;

      try {
        this.loading = true;
        const {
          RESOURCE_NAME: resourceName,
          RESOURCE_VALUE: resourceValue,
          TERM_ID: termId,
        } = this;
        const {
          title,
          description,
          stateDefine,
          pagesReference,
          timeCheckpoint,
          viewTime,
          comparisonCondition,
          durationActivity,
          startAtTime,
          startAtPeriod,
          previousStepRequired,
        } = this.form;

        const stateDefineId = pathOr(null, ["id"], stateDefine);
        const pagesReferenceId = pathOr(null, ["id"], pagesReference);
        const timeCheckpointId = pathOr(null, ["id"], timeCheckpoint);
        const comparisonConditionId = pathOr(null, ["id"], comparisonCondition);
        const diffTimeCheckpoint =
          comparisonConditionId === 0
            ? -1 * parseInt(viewTime)
            : parseInt(viewTime);

        const id = pathOr(null, ["id"], this.data); // get id for when updating mode
        const response = await this.submitMethod({
          resourceName,
          resourceValue,
          termId,
          id,
          title,
          description,
          stateDefineId,
          pagesReferenceId,
          timeCheckpointId,
          diffTimeCheckpoint,
          durationActivity: +durationActivity,
          startAtTime: +startAtTime,
          startAtPeriod: +startAtPeriod,
          previousStepRequired: +previousStepRequired,
          files: this.tempFiles,
        });
        const { message } = response;
        toastAlert(message);
        this.handleClose();
        this.handleReloadList();
      } catch (error) {
        generateError(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
